import { render, staticRenderFns } from "./LoggedUserMenu.vue?vue&type=template&id=6a3f8213"
import script from "./LoggedUserMenu.vue?vue&type=script&lang=js"
export * from "./LoggedUserMenu.vue?vue&type=script&lang=js"
import style0 from "./LoggedUserMenu.vue?vue&type=style&index=0&id=6a3f8213&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports